var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticStyle:{"margin":"18px"}},[_c('v-btn',{on:{"click":_vm.OpenAddClassroom}},[_vm._v("Add Classroom Schedule")]),_c('v-btn',{on:{"click":_vm.OpenAddWebinar}},[_vm._v("Add Online Schedule")]),_c('app-add-schedule',{ref:"Schedule",attrs:{"dialog":_vm.AddScheduleDialog},on:{"close":_vm.CloseDialog}}),_c('app-schedule-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }